import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_RapportFilter = _resolveComponent("RapportFilter")!

  return (_openBlock(), _createBlock(_component_RapportFilter, {
    startAt: _ctx.input.startAt,
    "onUpdate:startAt": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.input.startAt) = $event)),
    endAt: _ctx.input.endAt,
    "onUpdate:endAt": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.input.endAt) = $event)),
    period: _ctx.input.period,
    "onUpdate:period": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.input.period) = $event)),
    loading: _ctx.loading,
    onValidate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.initData())),
    label: "none"
  }, {
    table: _withCtx(() => [
      _createVNode(_component_DataTable, {
        paginator: false,
        value: _ctx.comparisons,
        rows: 20,
        onFilter: _ctx.onFilter,
        "rows-per-page-options": _ctx.rowsPerPageOptions,
        filters: _ctx.filters,
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
        filterDisplay: "menu",
        responsiveLayout: "scroll",
        class: "p-datatable-sm",
        "sort-field": "createdAt",
        "sort-order": 1,
        "show-gridlines": "",
        scrollable: "",
        "scroll-height": "flex"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_Button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refresh())),
            label: _ctx.$t('clear'),
            icon: "pi pi-refresh"
          }, null, 8, ["label"]),
          _createVNode(_component_Button, {
            disabled: !_ctx.comparisons.length,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.print())),
            label: _ctx.$t('pos.print'),
            icon: "pi pi-print"
          }, null, 8, ["disabled", "label"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            sortable: true,
            "sort-field": "createdAt",
            field: "createdAt",
            header: _ctx.$t('date'),
            "show-add-button": false,
            showFilterOperator: false,
            "filter-field": "createdAt",
            dataType: "date",
            "header-style": { 'min-width': '120px' },
            "body-style": { 'min-width': '120px' },
            "footer-style": { 'min-width': '120px' }
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(_ctx.$d(data.createdAt, "long")), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_Calendar, {
                manualInput: false,
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                dateFormat: _ctx.$t('format.range'),
                placeholder: _ctx.$t('format.range'),
                style: {"min-width":"200px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "dateFormat", "placeholder"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-database",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "income",
            header: _ctx.$t('rapport.payedIncome'),
            "show-add-button": false,
            showFilterOperator: false,
            sortable: true,
            "filter-field": "income",
            "sort-field": "income",
            dataType: "numeric",
            footer: `${_ctx.formatNumber(_ctx.filteredTotals.income)} ${_ctx.currencySymbol}`,
            "header-style": { 'min-width': '120px' },
            "body-style": { 'min-width': '120px' },
            "footer-style": { 'min-width': '120px' }
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_NumberFormatter, {
                value: data.income
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputNumber, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                "max-fraction-digits": 20,
                min: 0,
                mode: "decimal"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header", "footer"]),
          _createVNode(_component_Column, {
            field: "credit",
            header: _ctx.$t('rapport.unpayedIncome'),
            "show-add-button": false,
            showFilterOperator: false,
            sortable: true,
            "filter-field": "credit",
            "sort-field": "credit",
            dataType: "numeric",
            footer: `${_ctx.formatNumber(_ctx.filteredTotals.credit)} ${_ctx.currencySymbol}`,
            "header-style": { 'min-width': '120px' },
            "body-style": { 'min-width': '120px' },
            "footer-style": { 'min-width': '120px' }
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_NumberFormatter, {
                value: data.credit
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputNumber, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                "max-fraction-digits": 20,
                min: 0,
                mode: "decimal"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header", "footer"]),
          _createVNode(_component_Column, {
            field: "total",
            header: _ctx.$t('rapport.totalIncome'),
            "show-add-button": false,
            showFilterOperator: false,
            sortable: true,
            "filter-field": "total",
            "sort-field": "total",
            dataType: "numeric",
            footer: `${_ctx.formatNumber(_ctx.filteredTotals.total)} ${_ctx.currencySymbol}`,
            "header-style": { 'min-width': '120px' },
            "body-style": { 'min-width': '120px' },
            "footer-style": { 'min-width': '120px' }
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_NumberFormatter, {
                value: data.total
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputNumber, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                "max-fraction-digits": 20,
                min: 0,
                mode: "decimal"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header", "footer"]),
          _createVNode(_component_Column, {
            field: "expense",
            header: _ctx.$t('ticket.expenses'),
            "show-add-button": false,
            showFilterOperator: false,
            sortable: true,
            "filter-field": "expense",
            "sort-field": "expense",
            dataType: "numeric",
            footer: `${_ctx.formatNumber(_ctx.filteredTotals.expense)} ${_ctx.currencySymbol}`,
            "header-style": { 'min-width': '120px' },
            "body-style": { 'min-width': '120px' },
            "footer-style": { 'min-width': '120px' }
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_NumberFormatter, {
                value: data.expense
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputNumber, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                "max-fraction-digits": 20,
                min: 0,
                mode: "decimal"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header", "footer"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('rapport.balance'),
            "show-add-button": false,
            showFilterOperator: false,
            sortable: true,
            "filter-field": "balance",
            "sort-field": "balance",
            dataType: "numeric",
            footer: `${_ctx.formatNumber(_ctx.filteredTotals.balance)} ${_ctx.currencySymbol}`,
            "header-style": { 'min-width': '120px' },
            "body-style": { 'min-width': '120px' },
            "footer-style": { 'min-width': '120px' }
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_NumberFormatter, {
                value: data.balance
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputNumber, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                "max-fraction-digits": 20,
                min: 0,
                mode: "decimal"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            filterclear: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                type: "button",
                onClick: ($event: any) => (filterCallback()),
                class: "p-button-warning p-button-sm",
                label: _ctx.$t('prime.clear')
              }, null, 8, ["onClick", "label"])
            ]),
            filterapply: _withCtx(({ filterCallback }) => [
              _createVNode(_component_Button, {
                label: _ctx.$t('search'),
                type: "button",
                icon: "pi pi-search",
                class: "p-button-sm",
                onClick: ($event: any) => (filterCallback())
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          }, 8, ["header", "footer"])
        ]),
        _: 1
      }, 8, ["value", "onFilter", "rows-per-page-options", "filters"])
    ]),
    _: 1
  }, 8, ["startAt", "endAt", "period", "loading"]))
}